module.exports = __webpack_public_path__ + "static/media/siddharth-guntur-trip-33.9f1cc7c9.png";